import React from "react";
import { Form } from "react-bootstrap";

export const DesktopFilter = ({
  location,
  setLocation,
  partySize,
  setPartySize,
  bookingType,
  setBookingType,
  sortedLocations,
  sortedPartySizes,
  sortedBookingTypes,
}) => {
  return (
    <Form className="mb-3 animated fadeIn d-none d-md-block">
      <div className="row">
        <div className="col-md-4 col-4">
          <Form.Group>
            <label htmlFor="desktop-location">LOCATION</label>
            <select
              id="desktop-location"
              className="form-control custom-select"
              onChange={(e) => setLocation(e.target.value)}
              value={location}
            >
              <option value="all">All Location</option>
              {sortedLocations.map((loc) => (
                <option key={loc.slug} value={loc.slug}>
                  {loc.name}
                </option>
              ))}
            </select>
          </Form.Group>
        </div>
        <div className="col-md-4 col-4">
          <Form.Group>
            <label htmlFor="desktop-party-size">PARTY SIZE</label>
            <select
              id="desktop-party-size"
              className="form-control custom-select"
              onChange={(e) => setPartySize(e.target.value)}
              value={partySize}
            >
              <option value="all">All Size</option>
              {sortedPartySizes.map((size) => (
                <option key={size.slug} value={size.slug}>
                  {size.name}
                </option>
              ))}
            </select>
          </Form.Group>
        </div>
        <div className="col-md-4 col-4">
          <Form.Group>
            <label htmlFor="desktop-booking-type">TYPE OF BOOKING</label>
            <select
              id="desktop-booking-type"
              className="form-control custom-select"
              onChange={(e) => setBookingType(e.target.value)}
              value={bookingType}
            >
              <option value="all">All</option>
              {sortedBookingTypes.map((type) => (
                <option key={type.slug} value={type.slug}>
                  {type.name}
                </option>
              ))}
            </select>
          </Form.Group>
        </div>
      </div>
    </Form>
  );
};
